import './ColumnOrder.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var columnDndOverlay = '_1ku1w3z0-3-12-1';
export var headerDragAndDrop = {dragging:'_1ku1w3z5-3-12-1',enabled:'_1ku1w3z6-3-12-1',inactive:'_1ku1w3z7-3-12-1'};
export var insertPositionIndicator = _7a468({defaultClassName:'_1ku1w3z1-3-12-1',variantClassNames:{left:{true:'_1ku1w3z2-3-12-1',false:'_1ku1w3z3-3-12-1'}},defaultVariants:{},compoundVariants:[]});
export var verticalDividers = '_1ku1w3z4-3-12-1';